import { Box, Container, Drawer } from '@material-ui/core'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataTableNew from 'src/components/helperComponents/DataTable/DataTableNew'
import DialogComponent from 'src/components/helperComponents/DialogComponent'
import { DeleteNotificationById } from 'src/redux/actions'
import { GetNotificationsColumns } from 'src/util/columns'
import AddButton from 'src/components/helperComponents/AddButton'
import AddNotification from 'src/components/AddNotification'
const NotificationList = () => {
  const dispatch = useDispatch()

  const [recordToEdit, setRecordToEdit] = useState()
  const [recordToDelete, setRecordToDelete] = useState()
  const { reports } = useSelector(store => store.mainReducer)

  const onDeleteRow = () => {
    if (recordToDelete) {
      dispatch(DeleteNotificationById(recordToDelete))
      setRecordToDelete()
    }
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <AddButton type="Notification" onClick={() => setRecordToEdit({})} />
          <Drawer
            anchor="right"
            open={!!recordToEdit}
            onClose={() => setRecordToEdit()}
            PaperProps={{
              sx: {
                width: 400,
                top: 64,
                height: 'calc(100% - 64px)',
              },
            }}
          >
            <AddNotification
              selectedRow={recordToEdit}
              toggleDrawer={() => setRecordToEdit()}
            />
          </Drawer>
          <Box sx={{ pt: 3 }}>
            <DataTableNew
              data={reports}
              columns={GetNotificationsColumns(
                setRecordToEdit,
                setRecordToDelete
              )}
              apiName="notification"
            />
          </Box>
          {recordToDelete && (
            <DialogComponent
              title="Delete Notification"
              description="Do you want to delete the notification?"
              onDialogOk={onDeleteRow}
              onDialogCancel={() => setRecordToDelete(!recordToDelete)}
            />
          )}
        </Container>
      </Box>
    </>
  )
}

export default NotificationList
